import { createApp } from "vue";
import './integration/cf7'
import './integration/gravityforms'
import './integration/wpforms'

import App from "./App.vue";

(() => {
    const app = createApp(App);
    app.mount("#formychat-widgets");
})();